import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';


import { UserService } from '../_services/user.service';
import { NotificationService, NotificationType } from '../_services/notification.service'




@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})


export class UserProfileComponent implements OnInit {

  fileError: boolean = false;
  fileErrorText="";

  @ViewChild('passwordInfo', { static: false }) public tooltip: NgbTooltip;
  @ViewChild('nameInfo', { static: false }) public nametooltip: NgbTooltip;

  public edit: boolean = false;

  passwordNotMatch: boolean = true;
  public imageSave: boolean = false;
  public imageUrl: any;
  data: any;
  public activeModal: any;
  public userDetails:any={};
  public params: any = {};
  public firstNameErrorMsg;
  public lastNameErrorMsg;
  public validPasswordmessage;
  public firstNameValid: boolean = true;
  public lastNameValid: boolean = true;
  public previousPasswordmatch: boolean = true;
  public confirmPasswordShow;
  public passwordShow;
  public prevPasswordShow;
  public passwordValidationStatus: boolean = true;
  public imageloaded: boolean = false;
  public defaultpic: boolean = true;
  public mfaStatus: boolean;

  public userIcon = "data:image/png;base64,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";
  passwordForm: FormGroup;
  imageForm: FormGroup;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  nameForm: FormGroup;
  public errorMsg;
  public job_role:any;
  jobRoleChanges: boolean = false;
  mfaChanged: boolean = false;
  firstNameChanged: boolean;
  lastNameChanged: boolean;

  @ViewChild('firstName', { static: false }) firstName: ElementRef;
  @ViewChild('lastName', { static: false }) lastName: ElementRef;
  @ViewChild('jobRole', { static: false }) jobRole: ElementRef;



  constructor(private modalService: NgbModal,
    private userService: UserService,
    private _notificationService: NotificationService,
    private formBuilder: FormBuilder) {




    this.imageUrl = "assets/images/profile.jpg";
    this.data = {};
    // this.dataImage ="data:image/png;base64,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";




    this.passwordForm = this.formBuilder.group({
      previousPassword: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(50)]),
      confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(50)])
    });
    this.imageForm = this.formBuilder.group({
      imageUpload: new FormControl('')
    });



  }

  ngOnInit() {

    this.nameForm = this.formBuilder.group({
      firstName: new FormControl('', [Validators.required, Validators.maxLength(40), Validators.pattern("[a-zA-Z][a-zA-Z ]+")]),
      lastName: new FormControl('', [Validators.pattern("[a-zA-Z ]+")]),
      jobRole: new FormControl('', [])
    });

    this.getCurrentUser();
    if (!this.userDetails.avatar) {
      this.croppedImage = "";
    } else {
      this.croppedImage = this.userDetails.avatar;
    }

    if (this.userDetails.first_name < 1) {
      this.firstNameValid = false;
    }
    this.validateRemoveButton();

    this.mfaStatus = this.userDetails.mfa_enable;
  }


  open(content) {
    this.activeModal = this.modalService.open(content, {
      windowClass: "user-profile-pic",
      keyboard: true
    });
    this.validateRemoveButton();
  }

  validateRemoveButton() {
    
    if (this.userDetails.avatar == "" || this.croppedImage == "") {
      this.defaultpic = false;
    }
    else {
      this.defaultpic = true;
    }
  }


  firstNameCheck() {
    if (this.firstName.nativeElement.classList.contains('ng-invalid')) {
      this.firstNameValid = false;
      this.firstNameErrorMsg = "Please enter a valid  first name without numerics and special character(space excluded)";
      this.nametooltip.open();

    }
    else {
      this.firstNameValid = true;
      this.firstNameErrorMsg = " ";
      this.nametooltip.close();

    }
  }
  lastNameCheck() {
    if (this.lastName.nativeElement.classList.contains('ng-invalid')) {
      this.lastNameValid = false;
      this.lastNameErrorMsg = "Please enter a valid  last name without numerics and special character (space excluded) ";
      this.nametooltip.open();

    }
    else {
      this.lastNameValid = true;
      this.lastNameErrorMsg = " ";
      this.nametooltip.close();
    }
  }


  imgSave(imageData) {
    
    let notificationID = this._notificationService.showNotification({
      message: "Updating",
      type: NotificationType.info,
      isLoading: true
    })
    this._notificationService.notificationID.push(notificationID);

    this.params = {
      "imgstring": imageData
    }
    // console.log(imageData);
    this.userService.updateProfilePicture(this.params).subscribe(
      (result) => {
        

        let notifyID = this._notificationService.notificationID.shift();
        this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
        this.userService.UserImgUpdateEvent.emit(imageData);
        this.getCurrentUser();
        this.userDetails.avatar = imageData;
      },
      (error) => {
        console.log(error);
        if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
          let notifyID = this._notificationService.notificationID.shift();
          this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
        }
        this.croppedImage = this.userDetails.avatar;
      });
  }

  imgRemove(content) {
    let notificationID = this._notificationService.showNotification({
      message: "Updating",
      type: NotificationType.info,
      isLoading: true
    });
    this._notificationService.notificationID.push(notificationID);

    
    this.userService.deleteProfilePicture(this.userDetails._id).subscribe(
      (result) => {
        
        let notifyID = this._notificationService.notificationID.shift();
        this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
        this.userService.UserImgUpdateEvent.emit("");
        this.getCurrentUser();
        this.croppedImage = "";
        this.userDetails.avatar = "";
        this.validateRemoveButton();
        this.imageForm.reset();
        this.activeModal.close(content);
      },
      (error) => {
        console.log(error);
        if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
          let notifyID = this._notificationService.notificationID.shift();
          this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
        }
        this.croppedImage = this.userDetails.avatar;
      });
  }




  closeCrop() {
    if (!this.imageSave) {
      this.croppedImage = this.userDetails.avatar;
    }
  }
  getCurrentUser() {
  
    this.userDetails = this.userService.currentUser || {};
    

  }

  updateUserDetails() {
    let first_name = this.nameForm.value.firstName
    let last_name = this.nameForm.value.lastName
    let job_role = this.nameForm.value.jobRole

    if (this.firstNameValid || this.lastNameValid) {
      if (this.firstNameChanged) {
        this.params['modified_first_name'] = first_name;
      } else {
        this.params['modified_first_name'] = this.userDetails.first_name;
      }
      if (this.lastNameChanged) {
        this.params['modified_last_name'] = last_name;
      } else {
        this.params['modified_last_name'] = this.userDetails.last_name;
      }
      if (this.jobRoleChanges) {
        this.params['description'] = job_role;
      } else {
        this.params['description'] = this.userDetails.description;
      }
      if (this.mfaChanged) {
        this.params['mfa_enable'] = this.mfaStatus;
      } else {
        this.params['mfa_enable'] = this.userDetails.mfa_enable;
      }
      
      this.userService.updateUserDetails(this.params).subscribe(
        (result) => {
          this.userService.loadUserInfo();
          this._notificationService.showNotification({
            message: result["message"],
            type: NotificationType.success,
            isLoading: false,
          });
          if(this.firstNameChanged) {
            this.userDetails.first_name = first_name;
          }
          if(this.lastNameChanged) {
            this.userDetails.last_name = last_name;
          }
          this.mfaChanged = false;
          this.firstNameChanged = false;
          this.lastNameChanged = false;
          this.jobRoleChanges =  false;
          this.userService.UserNameUpdateEvent.emit();
        },
        (error) => {
          console.log(error);
          if (
            error.status !== 403 &&
            error.status !== 415 &&
            error.status !== 500
          ) {
            let notifyID = this._notificationService.notificationID.shift();
            this._notificationService.changeStatus(
              notifyID,
              NotificationType.error,
              error.error.message
            );
          }
        }
      );
    }

    Object.keys(this.nameForm.controls).forEach(field => {
      const control = this.nameForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  validatePassword() {
    var value = this.passwordForm.value;

    // console.log(value["previousPassword"])    
    // console.log(value["password"])
    // console.log(value["confirmPassword"])
    let weakPasswords = ["1234", "12345", "123456", "1234567", "12345678", "123456789", "qwerty", "qwer", "qwert", "qwe123", "123qwe", "asd123", "123asd", "asdf", "password", "pass"];

    for (var i = 0, len = weakPasswords.length; i < len; i++) {
      // console.log( value["password"].length);
      // console.log( value["password"].replace(/ +/g, "").length);

      if (weakPasswords[i] == value["password"]) {
        this.passwordValidationStatus = false;
        // console.log(`key is ${i} and value is ${value["password"]}`);
        this.validPasswordmessage = "Enter a strong password.";
        break;
      }
      else {
        if ((value["password"].length < 4) || (value["password"].length > 50) || (value["password"].replace(/ +/g, "").length != value["password"].length)) {
          this.tooltip.open();
          this.passwordValidationStatus = false;
          this.validPasswordmessage = "Enter a valid password.";

        }
        else {
          this.tooltip.close();
          this.passwordValidationStatus = true;
        }
      }

    }





    // Object.keys(weakPasswords).forEach(key => {
    //    if(value["password"] == weakPasswords[key]){

    //     console.log(`key is ${key} and value is ${value}`);
    //     this.passwordValidationStatus = false;

    //    }
    //    else{
    //     if(this.passwordValidationStatus){
    //      this.passwordValidationStatus = true;
    //     }
    //     console.log(this.passwordValidationStatus);
    //    }


    // });


  }

  updateDetails() {
    this.updatePassword();
    if(this.firstNameChanged || this.lastNameChanged || this.jobRoleChanges || this.mfaChanged) {
      this.updateUserDetails()
    }
  }

  updatePassword() {
    if (this.passwordValidationStatus) {
      var value = this.passwordForm.value;
      if(value["previousPassword"] != '' && value["password"] != '' && value["confirmPassword"] != '') {
        if (value["previousPassword"] == value["confirmPassword"]) {
          this.previousPasswordmatch = false;
        }
        else {
          this.previousPasswordmatch = true;

        }
        if (value["password"] != value["confirmPassword"]) {
          this.passwordNotMatch = false;
        }
        else {
          this.passwordNotMatch = true;
        }
        if (((this.passwordNotMatch == true)) && ((this.previousPasswordmatch == true))) {

          let notificationID = this._notificationService.showNotification({
            message: "Updating",
            type: NotificationType.info,
            isLoading: true
          })
          this._notificationService.notificationID.push(notificationID);
          this.params = {
            "password": value["previousPassword"],
            "new_password": value["password"]

          }
          this.userService.updatePassword(this.params).subscribe(
            (result) => {
              
              let notifyID = this._notificationService.notificationID.shift();
              this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);
              this.passwordForm.reset();
            },
            (error) => {
              if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
                let notifyID = this._notificationService.notificationID.shift();
                this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
              }
            }
          )
        }
      }
    }
  }

  validName(data, type) {
    
    if (type == "first_name") {
      if (data.length < 1 || data[0] == " ") {
        this.firstNameValid = false;
        this.firstNameErrorMsg = "Please enter a valid  first name ";
      }


      else if (data.length > 40) {
        this.firstNameValid = false;
        this.firstNameErrorMsg = "First name should be less than 40 characters ";
      }

      else {
        this.firstNameValid = true;

      }
      // validation check for special character
      this.firstNameCheck();
    }
    if (type == "last_name") {

      if (data.length > 40) {
        this.lastNameValid = false;
        this.lastNameErrorMsg = "last name should be less than 40 characters ";
      }
      else {
        this.lastNameValid = true;
      }
      // validation check for special character
      this.lastNameCheck();
    }


  }


  fileChangeEvent(event: any): void {
    var idxDot = event.target.files[0].name.lastIndexOf(".") + 1;
    var extFile = event.target.files[0].name.substr(idxDot, event.target.files[0].name.length).toLowerCase();
    if (event.target.files[0].size < 10485760 && (extFile =="jpg" || extFile =="jpeg" || extFile =="png")) {
      this.imageChangedEvent = event;
    }
    else {
      this.fileError = true;
      if(event.target.files[0].size > 10485760){
        this.fileErrorText = "Please upload a valid file less than 10 Mb of size"
      }else{
        this.fileErrorText = "Please upload a valid file in format such as .png, .jpg, .jpeg."
      }
      setTimeout(function () {
        this.fileError = false;
        this.fileErrorText = ""
      }.bind(this), 3000);
    }
  }
  imageCropped(image: string) {
    this.croppedImage = image;
  }
  imageLoaded() {
    this.imageloaded = true;
  }
  loadImageFailed() {
    // show message
  }

  mfaChangeHandler() {
    this.mfaChanged = true;
    this.nameForm.controls.firstName.markAsUntouched();
  }
}
